function normalizedOpenReplayPath(pathname: string): string | null {
  const raw = String(pathname ?? "")
  if (!raw.startsWith("/")) return null

  const separatorIndex = raw.search(/[?#]/)
  const path = (separatorIndex === -1 ? raw : raw.slice(0, separatorIndex)) || "/"

  return path.replace(/^\/[a-z]{2}(?=\/|$)/i, "") || "/"
}

export function isOpenReplaySensitiveRoute(pathname: string): boolean {
  const path = normalizedOpenReplayPath(pathname)
  if (!path) return true

  return (
    /^\/checkout\/recover\/?$/i.test(path) ||
    /^\/verify-account\/?$/i.test(path) ||
    /^\/content-preview\/?$/i.test(path) ||
    /^\/garanti-return\/?$/i.test(path) ||
    /^\/order\/[^/]+\/transfer\/[^/]+(?:\/(?:accept|decline))?\/?$/i.test(path)
  )
}

export function isOpenReplayRouteEligible(pathname: string): boolean {
  const raw = String(pathname ?? "")
  return raw.startsWith("/") && !isOpenReplaySensitiveRoute(raw)
}
